import { Box, Image } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import HeaderMobile from 'Component/header-mobile';
import useIsMobile from 'Hook/useIsMobile';
import { Condition } from 'Component/others';
import { useNavigate } from 'react-router-dom';
import forbiddenImage from 'Asset/image/forbidden-data.svg';

import styles from './styles.module.css';

const ForbiddenSchedule = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Box className={styles['forbidden-schedule__container']}>
      <Condition statement={isMobile}>
        <HeaderMobile title="Forbidden page" type="header-back" onClick={() => navigate('/')} />
      </Condition>

      <Image src={forbiddenImage} className={styles['forbidden-schedule__image']} />
      <TextBold className={styles['title__text']}>Jadwal Sudah Dipindahkan</TextBold>
      <TextRegular className={styles['description__text']}>Halaman ini tidak bisa diakses karena jadwal sudah ditugaskan ke host lain.</TextRegular>
    </Box>
  );
};

export default ForbiddenSchedule;
